"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /* eslint-disable react/no-unused-state */
const throttleLength = 1000 / 15; // 15 fps

/**
 * Helper function that wraps the passed in component
 * with a component that passes in the window size as props.
 *
 * @example
 * class Component extends React.Component {
 *   render() {
 *     const { width, height } = this.props.windowDimensions;
 *     return <div>{width} - {height}</div>
 *   }
 * }
 *
 * export default withWindowDimensions(Component);
 */
const withWindowDimensions = WrappedComponent => {
  var _WindowDimensions;
  return _WindowDimensions = class WindowDimensions extends _react.Component {
    constructor(...args) {
      super(...args);
      /**
       * Property that exposes the `WrappedComponent` to tests
       *
       * @example
       * class Component extends React.Component {
       *   render() {}
       * }
       *
       * const WithWindowSize = withWindowSize(Component);
       *
       * const wrapper = mount(WithWindowSize);
       *
       * // returns instance of Component
       * wrapper.find(WithWindowSize.WrappedComponent);
       */
      // eslint-disable-next-line react/state-in-constructor
      this.state = {
        width: window.innerWidth,
        height: window.innerHeight
      };
      /**
       * Prevents window.resize from causing components to re-render a ton.
       */
      this.updateDimensionsWithThrottle = () => {
        if (this.resizeThrottle) {
          return;
        }
        this.resizeThrottle = setTimeout(() => {
          this.resizeThrottle = null;
        }, throttleLength);
        this.updateWindowDimensions();
      };
    }
    componentDidMount() {
      window.addEventListener("resize", this.updateDimensionsWithThrottle);
    }
    componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensionsWithThrottle);
    }
    updateWindowDimensions() {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    render() {
      return /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({
        windowDimensions: this.state
      }, this.props));
    }
  }, _WindowDimensions.WrappedComponent = WrappedComponent, _WindowDimensions;
};
var _default = exports.default = withWindowDimensions;